export default "__VITE_ASSET__tYL$yBy1__"